import { render, staticRenderFns } from "./sogospread.vue?vue&type=template&id=1e6b5626&"
import script from "./sogospread.vue?vue&type=script&lang=js&"
export * from "./sogospread.vue?vue&type=script&lang=js&"
import style0 from "./sogospread.vue?vue&type=style&index=0&id=1e6b5626&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports